define('CopyrightDate.Helper', [], function () {
	'use strict';

	return {
		isModuleLoaded: function(moduleName) {
      var loadedModules = SC && SC.ENVIRONMENT && SC.ENVIRONMENT.JS_MODULE_NAMES;
      var isLoaded = false;

      if ( loadedModules && Array.isArray(loadedModules) ) {

        var l = loadedModules.length;

        for (var i = 0; i < l; i++) {
          
          if ( loadedModules[i] == moduleName ) {
            isLoaded = true;
            break;
          }
        }
      }

      return isLoaded;

		},

		getFullYear: function() {
      return new Date().getFullYear();
		},

	};
});
